/* ── Email backend: Apps Script web app, sends from nm@neerajmandhana.com ──
   The script (apps-script/Code.gs) is deployed as a Web App; this posts to it.
   Shared by the lead dashboard and the Trusted Partners section. */
const MAILER_URL    = "https://script.google.com/macros/s/AKfycbw-oBdqfLsZfLLgZfsqGU_cA4pmIyfv3SiGlSvWJJ_0FF07Dw3YWg4RrNU-jNNOUZj_/exec";
const MAILER_SECRET = "0841e245bd4756738548087ddba5d00c";

/* POST to the Apps Script mailer. Returns { ok, error }; never throws.
   text/plain keeps this a CORS "simple request" so there is no OPTIONS
   preflight, which Apps Script web apps reject.
   Note: the script validates `to` as a single address; put extra
   recipients in `cc` (passed through unvalidated). */
export async function sendMail({ to, subject, html, replyTo, cc, fromName }) {
  try {
    const res = await fetch(MAILER_URL, {
      method: "POST",
      redirect: "follow",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify({ secret: MAILER_SECRET, to, subject, html, replyTo, cc, fromName }),
    });
    const data = await res.json();
    return { ok: !!data.ok, error: data.error };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

/* Upload a file to Google Drive via the same Apps Script web app. The script
   saves it under a per-student folder in nm@neerajmandhana.com's Drive and
   returns { url, id }. Used for TUAP onboarding documents. Throws on failure
   so the caller can show an error. */
export async function uploadToDrive({ studentId, studentName, key, file }) {
  const dataBase64 = await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(",")[1] || "");
    r.onerror = () => reject(new Error("Could not read the file."));
    r.readAsDataURL(file);
  });
  const res = await fetch(MAILER_URL, {
    method: "POST",
    redirect: "follow",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify({
      secret: MAILER_SECRET, action: "upload",
      studentId, studentName, key,
      fileName: file.name, mimeType: file.type, dataBase64,
    }),
  });
  const data = await res.json();
  if (!data.ok) throw new Error(data.error || "Upload failed");
  return { url: data.url, id: data.id };
}

/* Email a 6-digit verification code (the code is generated + stored server-side
   in the Apps Script, never exposed to the browser). Used to gate portals. */
export async function sendOtp(key, email) {
  try {
    const res = await fetch(MAILER_URL, {
      method: "POST", redirect: "follow",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify({ secret: MAILER_SECRET, action: "sendOtp", key, email }),
    });
    const d = await res.json();
    return { ok: !!d.ok, error: d.error };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

export async function verifyOtp(key, email, code) {
  try {
    const res = await fetch(MAILER_URL, {
      method: "POST", redirect: "follow",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify({ secret: MAILER_SECRET, action: "verifyOtp", key, email, code }),
    });
    const d = await res.json();
    return { ok: !!d.ok, error: d.error };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}
